<template>
  <div>
    <div class="module-result-content1">
      <div class="result-content1">
        <el-table
            :data="companyList"
            height="calc(100vh - 160px)"
            width="100%"
            :header-cell-style="{fontSize:'13px',}"
            :row-style="{fontSize:'13px',cursor:'pointer'}"
            class="tableBox"
            @selection-change="handleSelectionChange"
            :row-class-name="getRowClass()"
        >
          <el-table-column
              type="selection"
          >
          </el-table-column>
          <el-table-column
              fixed
              label="公司名称"
              width="150px"
              align="left"
              :show-overflow-tooltip="true"
          >
            <template slot="header">
              <div style="text-align: left">公司名称</div>
            </template>
            <template scope="scope">
              <div class="companyInfoNameText" @click="detaileClick(scope.row)">
                {{ scope.row.name }}
              </div>
            </template>

          </el-table-column>
          <el-table-column
              prop="grade"
              label="等级"
              style="flex: 0.1 0.1 0"
              align="center"

          >
            <template scope="scope">
              <div class="companyInfoLevel" @click="detaileClick(scope.row)">
                <div class="companyLevelText">{{ scope.row.grade|levelType }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="mailSuffix"
              label="公司邮箱后缀"
              style="flex: 0.15 0.15 0"
              align="left"
              :show-overflow-tooltip="true"
          >
            <template scope="scope">
              <div class="companyInfoEmailSuffix" @click="detaileClick(scope.row)">
                <span v-if="scope.row.mailSuffix!==''">{{ scope.row.mailSuffix }}</span>
                <span v-if="scope.row.mailSuffix===''">--</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="contactPerson"
              label="公司联系人"
              style="flex: 0.1 0.1 0"
              align="center"
              :show-overflow-tooltip="true"
          >
            <template scope="scope">
              <div class="companyInfoLiaison" @click="detaileClick(scope.row)">
                <span v-if="scope.row.contactPerson!==''">{{ scope.row.contactPerson }}</span>
                <span v-if="scope.row.contactPerson===''">--</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="contactPersonTel"
              label="联系人电话"
              style="flex: 0.2 0.2 0"
              align="left"
              :show-overflow-tooltip="true"
          >
            <template slot="header">
              <div style="text-align: left">联系人电话</div>
            </template>
            <template scope="scope">
              <div class="compayLiaisonPhone" @click="detaileClick(scope.row)">
                <span v-if="scope.row.contactPersonTel!==''">{{ scope.row.contactPersonTel }}</span>
                <span v-if="scope.row.contactPersonTel===''">--</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="contactPersonMail"
              label="联系人邮箱"
              style="flex: 0.15 0.15 0"
              align="left"
              :show-overflow-tooltip="true"
          >
            <template slot="header">
              <div style="text-align: left">联系人邮箱</div>
            </template>
            <template scope="scope">
              <div class="liaisonInfoEmail" @click="detaileClick(scope.row)">
                <span v-if="scope.row.contactPersonMail!==''">{{ scope.row.contactPersonMail }}</span>
                <span v-if="scope.row.contactPersonMail===''">--</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="groupName"
              label="负责组"
              style="flex: 0.07 0.07 0"
              align="center"
          >
            <template scope="scope">
              <div class="companyInfoResGroup" @click="detaileClick(scope.row)">
                <span v-if="scope.row.groupName!==null">{{ scope.row.groupName }}</span>
                <span v-if="scope.row.groupName===null">--</span>
              </div>
            </template>

          </el-table-column>
          <el-table-column
              prop="principalName"
              label="负责人"
              style="flex: 0.07 0.07 0"
              align="center"
          >
            <template scope="scope">
              <div class="companyInfoResPerson" @click="detaileClick(scope.row)">
                <span v-if="scope.row.principalId!==''">{{ scope.row.principalName }}</span>
                <span v-if="scope.row.principalId===''">--</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="description"
              label="描述"
              style="flex: 0.16 0.16 0"
              align="center"
          >
            <template scope="scope">
              <div class="companyInfoDescribe" @click="detaileClick(scope.row)">
                <div class="companyDescribeText">
                  <span v-if="scope.row.description!==''">{{ scope.row.description }}</span>
                  <span v-if="scope.row.description===''">--</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              fixed="right"
              label="操作"
              align="center"
              width="120"
          >
            <template scope="scope">
              <div class="companyInfoOperate">
                                <span class="customerRevise">
                                    <img src="../../../assets/images/fieldmanage/rivese.png"
                                         style="width: 16px;height: 16px" @click="editCompany(scope.row.id,scope.row)"/>
                                </span>
                <span class="customerDel">
                                <img src="../../../assets/images/fieldmanage/delred.png"
                                     style="width: 16px;height: 16px" @click="deleteCompany(scope.row.id)">
                               </span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog title="编辑公司" :visible.sync="dialogFormVisible" custom-class="customerListDialog" style="text-align: left"
               :close-on-click-modal="false">
      <div class="companyFlexClass">
        <div class="companyFlexClass1"><span class="keyred">*</span>公司名称</div>
        <div class="companyFlexClass2">
          <el-input
              placeholder="请输入公司名称"
              v-model="companyName"
              clearable
          >
          </el-input>
        </div>
      </div>
      <div class="companyFlexClass">
        <div class="companyFlexClass1">
          等级
        </div>
        <div class="flexClass2">
          <el-radio v-model="radio" label="NORMAL">普通</el-radio>
          <el-radio v-model="radio" label="VIP">vip</el-radio>
        </div>
      </div>
      <div class="companyFlexClass">
        <div class="companyFlexClass1">公司邮箱后缀
          <el-popover
              placement="top-start"
              width="230"
              trigger="hover"
          >
            <span style="color: #F56C6C">客户主邮箱的后缀是企业邮箱后缀时，将被自动添加到该公司</span>

            <span slot="reference" style="margin-left: 4px;height: 20px;text-align: center">
                                         <i class="el-icon-warning-outline" style="font-size: 14px;color: #AAAAAA"></i>
                                    </span>
          </el-popover>
        </div>
        <div class="companyFlexClass2">
          <el-input
              placeholder="请输入公司邮箱后缀"
              v-model="emaiSuffix"
              clearable
          >
          </el-input>
        </div>
      </div>
      <div class="companyFlexClass">
        <div class="companyFlexClass1">公司联系人</div>
        <div class="companyFlexClass2">
          <el-input
              placeholder="请输入公司联系人姓名"
              v-model="contactPerson"
              clearable
          >
          </el-input>
        </div>
      </div>
      <div class="companyFlexClass">
        <div class="companyFlexClass1">联系人电话</div>
        <div class="companyFlexClass2">
          <el-input
              placeholder="请输入公司联系人电话"
              v-model="contactPersonTel"
              clearable
              @blur="phoneBlurClick"
          >
          </el-input>
        </div>
      </div>
      <div class="companyFlexClass">
        <div class="companyFlexClass1">联系人邮箱</div>
        <div class="companyFlexClass2">
          <el-input
              placeholder="请输入联系人邮箱"
              v-model="contactPersonMail"
              clearable
              @blur="emaiBblurClick"
          >
          </el-input>
        </div>
      </div>
      <div class="companyFlexClass">
        <div class="companyFlexClass1">负责组</div>
        <div class="companyFlexClass2">
          <el-select v-model="groupValue"
                     clearable
                     placeholder="请选择或者搜索负责组"
                     style="width: 100%;position: relative"
                     @change="getAccountPerson"

          >
            <div style="margin: 5px 0">
              <el-input
                  placeholder="可搜索"
                  v-model="inputselect"
                  clearable
                  style="position: absolute;top: 0;z-index: 9"
                  @input="changeSelectGroup"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
            <div v-if="selectGroupList.length===0">
              <el-option value="" style="height: 5px"></el-option>
            </div>
            <div style="margin-top: 32px">
              <el-option
                  v-for="item in selectGroupList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </div>

          </el-select>
        </div>
      </div>
      <div class="companyFlexClass">
        <div class="companyFlexClass1">负责人</div>
        <div class="companyFlexClass2">
          <el-select v-model="personValue"
                     clearable
                     placeholder="请选择或者搜索负责人"
                     style="width: 100%;position: relative"
          >

            <div>
              <el-input
                  placeholder="可搜索"
                  v-model="inputselect"
                  clearable
                  style="position: absolute;top: 0;z-index: 9"
                  @input="changeSelectPerson"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
            <div v-if="selectPersonList.length===0">
              <el-option value="" style="height: 5px;"></el-option>
            </div>
            <div style="margin-top: 32px">
              <el-option
                  v-for="item in selectPersonList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </div>

          </el-select>
        </div>
      </div>
      <div style="display: flex;padding: 6px 0 0 0">
        <div style="flex: 0.2 0.2 0;height: 40px;line-height: 40px;">描述</div>
        <div style="flex: 0.8 0.8 0">
          <el-input
              type="textarea"
              :rows="2"
              placeholder="对该公司的描述"
              v-model="description">
          </el-input>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="modifyClientCompanyClick">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog
        title="删除公司"
        :visible.sync="dialogVisible"
        custom-class="customerInfoItemDialog"
        style="text-align: left;"
        :close-on-click-modal="false"


    >
      <div class="companyDeleteText">
        <div class="isDelete" style="font-size: 14px;margin-bottom: 8px"> 是否删除该公司？</div>
        <div class="promptText" style="font-size: 14px">删除公司后，该公司下的所有客户都将被删除，请谨慎操作！</div>
      </div>

      <span slot="footer" class="dialog-footer">
                            <el-button @click="dialogVisible = false">取 消</el-button>
                            <el-button @click="deleteClientCompanyInfo"
                                       style="background-color: red;color: white">删 除</el-button>
                          </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  name: "CompanyListInfoItem",
  props: {
    companyInfo: {
      type: Object,
      default() {
        return {}
      }

    },
    companyList: {
      type: Array,
      default() {
        return []
      }
    },
    index: Number,
    isCheck: Boolean
  },
  data() {
    return {
      dialogVisible: false,
      dialogFormVisible: false,
      input: '',
      inputphone: '',
      inputemail: '',
      radio: 'NORMAL',
      inputselect: '',
      value: '',
      companyValue: '',
      groupValue: '',
      personValue: '',
      textarea: '',
      company: 0,
      checked: false,
      companyName: '',
      emaiSuffix: '',
      contactPerson: '',
      contactPersonMail: '',
      contactPersonTel: '',
      description: '',
      accountGroup: {
        list: []
      },
      accountPerson: {
        list: []
      },
      groupName: '',
      personName: '',
      accountGroupPerson: {
        list: []
      },
      selectGroupList: [],
      selectPersonList: [],
      companyInfoCheck: [],
      companyDetailId: ''

    }
  },
  mounted() {

    this.getAccountGroup()
    console.log(this.companyInfo)
  },
  filters: {
    levelType(value) {
      if (value === 'NORMAL')
        return '普通'
      if (value === 'VIP')
        return 'VIP'
    }
  },
  methods: {
    //获取行样式
    getRowClass() {
      return 'rowClass'
    },

    detaileClick(row) {
      this.$router.push({
        path: '/companydetails',
        query: {
          id: row.id,
          companyUrl: 'companydetails'
        }
      })
    },
    deleteCompany(companyId) {
      this.companyDetailId = companyId
      this.dialogVisible = true
    },
    deleteClientCompanyInfo() {
      this.$http.delete('/api/client-company/' + this.companyDetailId).then(res => {
        if (res.data.code === '0') {
          this.$message.success('删除公司信息成功')
        }
        this.$emit('deleteClientCompanyInfo')

      })
      this.dialogVisible = false


    },
    modifyClientCompanyClick() {

      if (this.companyName !== '') {
        this.$http.put('/api/client-company/' + this.companyDetailId, {
          updateTime: new Date(),
          contactPerson: this.contactPerson,
          contactPersonMail: this.contactPersonMail,
          contactPersonTel: this.contactPersonTel,
          description: this.description,
          groupId: this.groupValue,
          name: this.companyName,
          principalId: this.personValue,
          grade: this.radio,
          mailSuffix: this.emaiSuffix
        }).then(res => {
          if (res.data.code === '0') {
            this.$message.success('修改公司信息成功')
          }
          this.$emit('modifyClientCompanyClick')
        })
        this.dialogFormVisible = false
      } else
        this.$message('请填写公司名称')


    },
    getAccountGroup() {
      this.$http.get('/api/account/group').then(res => {
        this.accountGroup.list = res.data.data
        this.selectGroupList = res.data.data
        console.log(this.companyInfo)
        this.selectGroupList.find((item) => {
          this.companyList.forEach(items => {
            if (item.id === items.groupId) {
              this.groupValue = item.id
              this.groupName = item.name

            }
          })


        })
        this.getAccountPerson()

      })
    },
    //获取负责人的下拉列表值
    getAccountPerson() {
      if (this.groupValue !== '') {
        this.$http.get('/api/account/principal?groupId=' + this.groupValue).then(res => {
          this.accountPerson.list = res.data.data
          this.selectPersonList = res.data.data

        })
      }
      if (this.groupValue === '') {
        this.$http.get('/api/account/principal?groupId=%20').then(res => {
          this.accountPerson.list = res.data.data
          this.selectPersonList = res.data.data

        })
      }
    },
    companyCheck(value) {
      this.companyInfoCheck = this.companyInfo
      this.$emit('companyCheck', value, this.companyInfoCheck, this.index)
    },
    editCompany(customerId, companyDetail) {
      this.personValue = ''
      this.companyDetailId = customerId
      this.companyName = companyDetail.name
      this.contactPerson = companyDetail.contactPerson
      this.contactPersonMail = companyDetail.contactPersonMail
      this.contactPersonTel = companyDetail.contactPersonTel
      this.description = companyDetail.description
      this.emaiSuffix = companyDetail.mailSuffix
      this.groupValue = companyDetail.groupId
      this.personValue = companyDetail.principalId
      this.radio = companyDetail.grade
      this.dialogFormVisible = true
    },
    emaiBblurClick() {

      const reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      if (this.contactPersonMail !== '') {
        if (!reg.test(this.contactPersonMail))
          this.$message('请输入有效的邮箱')
      }

    },
    phoneBlurClick() {
      const phone = /^[1][3,4,5,7,8][0-9]{9}$/
      if (this.contactPersonTel !== '') {
        if (!phone.test(this.contactPersonTel))
          this.$message('请输入有效的电话号码')
      }

    },
    //获取受理组的搜索下拉
    changeSelectGroup(value) {
      if (value !== '') {
        let selectCompany = []
        this.accountGroup.list.forEach((item) => {
          if (!!~item.name.indexOf(value) || !!~item.name.toUpperCase().indexOf(value.toUpperCase())) {
            selectCompany.push(item)
          }
        })
        this.selectGroupList = selectCompany

      } else {
        this.selectGroupList = this.accountGroup.list
      }

    },

    //获取受理人的搜索下拉
    changeSelectPerson(value) {
      if (value !== '') {
        let selectPerson = []
        this.accountPerson.list.forEach((item) => {
          if (!!~item.name.indexOf(value) || !!~item.name.toUpperCase().indexOf(value.toUpperCase())) {
            selectPerson.push(item)
          }
        })
        this.selectPersonList = selectPerson

      } else {
        this.selectPersonList = this.accountPerson.list
      }
    },

    //选择要分享的公司
    handleSelectionChange(value) {
      this.$emit('handleSelectionChange', value)
    }

  },
  watch: {
    isCheck: function (a) {
      if (a === true)
        this.checked = true
      if (a === false)
        this.checked = false
      console.log(a)
    },
    companyList: function (a) {
      this.companyList = a
      console.log(a)
    }

  }
}
</script>

<style lang="less">
@import "../../../assets/less/customlist/companylistinfo/companylistinfoitem";

.module-result-content1 {
  flex: 1;
  display: flex;
  flex-direction: column;

  .result-content1 {
    flex: 1;
    position: relative;

    .el-table {
      position: absolute;
      overflow: hidden;

    }
  }
}

.tableBox {
  th {
    padding: 0 !important;
    height: 72px;
    line-height: 72px;
  }

  td {
    padding: 0 !important;
    height: 72px;
    line-height: 72px;
  }
}

.rowClass {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
}
</style>